import { createContext, useContext } from "react";

/* The site is now mounted underneath the intro overlay rather than after it, so
 * that the WebGL context, shaders and particle buffers are all live by the time
 * the overlay lifts. That means the landing's entrance animations would
 * otherwise play against a black curtain and be over before anyone saw them -
 * including the `whileInView` ones, since an IntersectionObserver happily fires
 * for an element hidden behind an opaque overlay.
 *
 * Components hold their entrance at "hidden" until this flips.
 */
const RevealContext = createContext(true);

export const RevealProvider = RevealContext.Provider;

/** True once the intro has finished and the site is actually being looked at. */
export const useRevealed = () => useContext(RevealContext);
